import { createMigrate } from "redux-persist";
import store from "./store";
export const migrations = {
    // 🔥 Version 1 migration (first ever)
    1: (state: any) => {
        if (!state) return state;

        return {
            ...state,
            items: {
                ...state.items,
            },
        };
    },
    2: (state: any) => {
        if (!state) return state;

        return {
            ...state,
            items: {
                ...state.items,

            },
        };
    },
};

export const migrate = createMigrate(migrations, {
    debug: false, // set true temporarily if needed
});
